<template>
  <div class="military-lending-act-style" v-if="military.isShowMilitaryLendingAct">
    <template>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <i icon class="material-icons font-style"
             v-bind="attrs" v-on="on"
             :color="military.color"
             @click="checkMilitary"
             large
             :style="{color: military.color}">military_tech</i>
        </template>
        <span>Military Lending Act</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>

import { Cache, Crypto, DataType, Tool, Popup } from '@/util/index'
import { MyDebounce } from '@/util/debounce'
import { OriginationBusinessApi } from '@/api/pandaria'
const tool = new Tool()
const cache = new Cache()
const popup = new Popup()
const debounce = new MyDebounce()
export default {
  name: 'military-lending-act',
  props: {
    loan: Object,
    operator: Object
  },
  data () {
    return {
      militaryLendingActClass: '',
      military: {
        color: '#F44336',
        isShowMilitaryLendingAct: false
      },
      locked: ''
    }
  },
  created () {
    this.getLoanMilitary()
  },
  mounted () {
    this.$eventBus.$on('militaryLendingAct', target => {
      if (tool.isNotEmpty(target)) {
        this.initIsShowMilitary(target.military)
      }
    })
    this.$eventBus.$on('broadcastLockedId', target => {
      this.locked = target
    })
  },
  computed: {
    loanId () {
      return parseInt(Crypto.decrypt(cache.getSessionLoanId()), 10)
    },
    loanData () {
      return this.loan
    },
    operatorData () {
      return this.operator
    }
  },
  methods: {
    initIsShowMilitary (military) {
      this.militaryLendingActClass = military
      if (military === DataType.MilitaryEnum.NOT_MILITARY.value) {
        this.military.isShowMilitaryLendingAct = false
      } else {
        this.military.isShowMilitaryLendingAct = true
        if (military === DataType.MilitaryEnum.UNKNOWN.value) {
          this.military.color = '#FF9700'
        } else {
          this.military.color = '#F44336'
        }
      }
    },
    getLoanMilitary () {
      const $this = this
      OriginationBusinessApi.getLoanMilitary({ loanId: this.loanId }, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.initIsShowMilitary(result.military)
        }
      }, function (error) {
        popup.popupForWarning(error.message)
      })
    },
    // debounce防抖
    checkMilitary: debounce.debounce(function () {
      const $this = this
      const loanStatus = this.loanData.loanStatus
      if (loanStatus === DataType.LoanStatus.AGENT_REVIEW.value || loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value || loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        if (this.locked === this.operatorData.id) {
          if (this.militaryLendingActClass !== DataType.MilitaryEnum.MILITARY.value) {
            OriginationBusinessApi.getManualVerify({ loanId: this.loanId }, function (result) {
              if (tool.isNotEmpty(result)) {
                $this.initIsShowMilitary(result.military)
              }
            }, function (error) {
              popup.popupForWarning(error.message)
            })
          }
        } else {
          popup.popupForWarning('Current loan is locked by others')
        }
      } else {
        popup.popupForWarning('MLA cannot be verified for the loan in this status, please change the loan status to Agent Review ,Corrector Review or Application Review firstly. ')
      }
    }, 500)
  },
  destroyed () {
    this.$eventBus.$off('militaryLendingAct')
  }
}
</script>

<style lang="scss" scoped>
  .military-lending-act-style {
    border-top-right-radius: 6px;
    display: block;
    position: relative;
    float: right;
    color: white;
    opacity: 0.88;
    height: 10px;
    margin-right: 10px;
    cursor: pointer;
    margin-top: 1px;
  }
  .material-icons.md-36 { font-size: 36px; }
  .material-icons.md-48 { font-size: 48px; }
  .group {
    display: flex;
    flex: 1;
    justify-content: space-around;
  }
  .font-style {
    cursor: pointer;
    font-size: 36px;
  }
</style>
